
import './ScheduleAppointment.scss';
import { useSearchParams } from 'react-router-dom';
// Components
import Header from "../components/Header/Header";
import Form from "../components/Form/Form"
import Footer from "../components/Footer/Footer";
import Wppbtn from '../components/Wppbtn/Wppbtn';
// Metadata Component 
import MetaTags from '../components/MetaTags/MetaTags';

function ScheduleAppointment() {
  const [searchParams] = useSearchParams();
  const defaultPlan = searchParams.get('plan') || '';
  
  return (
    <div className="schedule-appointment">
      <MetaTags
                title='Licenciada en Nutrición Belén Olivera | Agenda'
                description='Agenda una consulta con la nutricionista Belén Olivera. ¡Hagamos de tu bienestar una prioridad y comencemos esta transformación juntos!'
                image='images/logotipo-white-desktop.png'
                name='Lautaro Tamborindeguy'
            />
      <Header />
      <main>
        <Form defaultPlan={defaultPlan} />
      </main>
      <Footer />
      <Wppbtn />
    </div>
  );
}

export default ScheduleAppointment;